import type { FC } from 'react';
import { useEffect } from 'react';
import {
  FormControl, InputLabel, Select, MenuItem, Grid,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

interface INavigationProps {
  pages: string[],
  pageSelected?: string,
  handlePageChange: (selectedPage: string) => void;
}

const NavigationDropdown: FC<INavigationProps> = (
  { pages, pageSelected, handlePageChange },
) => {
  const useStyles = makeStyles(() => createStyles({
    formControl: {
      margin: '20px',
      width: '200px',
      float: 'right',
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    if (pageSelected === undefined) {
      handlePageChange('Current');
    }
  }, [handlePageChange, pageSelected]);

  return (
    <Grid>
      <FormControl className={classes.formControl}>
        <InputLabel id="next-pg-label">{'Scan Action'}</InputLabel>
        <Select
          value={pageSelected || 'Current'}
          labelId="next-pg-label"
          id="next-pg-select"
          label="Next Page"
          onChange={(event) => {
            handlePageChange(JSON.stringify(event.target.value));
          }}
        >
          {pages.map((p) => (
            <MenuItem
              value={p}
              key={p}
            >
              {p}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default NavigationDropdown;
